const initialState = {}

export default function adminUser (state = initialState, action) {
  switch (action.type) {
    case 'ADMIN_LOGIN_REQUEST':
      return {
        loggingIn: true,
      }
    case 'ADMIN_LOGIN_SUCCESS':
      return {
        loggedIn: true,
        user: action.user
      }
    case 'ADMIN_LOGIN_FAILURE':
      return {}
    case 'ADMIN_SET_TOKENS':
      let newState = { ...state }
      newState.user.tokens = action.payload
      return newState
    case 'ADMIN_LOGOUT':
      return {}
    default:
      return state
  }
}
